import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import dynamic from 'next/dynamic';
import { useStyles } from './styles';
import { COLOR_PURPLE } from 'styles/variables/colors';
import HeaderInformation from '../HeaderInformation';

const DynamicCustomLandingPage = dynamic(() => import('components/CustomLandingPage'));
const DynamicBookDemo = dynamic(() => import('components/BookDemo'));
const DynamicBenefitedDepartments = dynamic(() => import('components/BenefitedDepartments'));
const DynamicPublishedSection = dynamic(() => import('components/PublishedSection'));
const DynamicInstitutionsCommunication = dynamic(() =>
  import('components/InstitutionsCommunication'),
);
const DynamicTrustedOneHundredInstitutions = dynamic(() =>
  import('components/TrustedOneHundredInstitutions'),
);
const DynamicCreatingScienceIllustrations = dynamic(() =>
  import('components/CreatingScienceIllustrations'),
);
const DynamicReferToAcademicInstitution = dynamic(() =>
  import('components/ReferToAcademicInstitution'),
);

export default function AcademicContent() {
  const classes = useStyles();

  return (
    <>
      <Box py={3} bgcolor={COLOR_PURPLE} height={239}>
        <Container>
          <HeaderInformation
            marginLeftPercentage={27}
            textTitle={
              <>
                For Academic <br /> Institutions
              </>
            }
            textDescription={
              <>
                Get in touch with our team to learn how Mind the Graph can <br />
                assist your institution to stimulate scientific communication. <br />
                View some of our use cases in which other universities and <br />
                colleges are already inspiring scientific outcomes.
              </>
            }
          />
        </Container>
      </Box>

      <DynamicInstitutionsCommunication
        textTitle={
          <>
            The best science infographic maker <br /> for scholarly communication
          </>
        }
        textInformation={
          <>
            Academic users can easily create beautiful graphical abstracts, <br />
            presentations, infographics and more. Browse through 75,000+ <br />
            scientifically-accurate illustrations in more than 80 study fields.
          </>
        }
        textButton="Inspire Science Outcomes"
      />

      <DynamicCustomLandingPage
        textTitle={
          <>
            Custom landing page <br /> with email authentication
          </>
        }
        textDescription={
          <>
            Use the institution's visual identity to <br />
            <b>strengthen the brand experience</b> while <br />
            protecting user data. Through domain-
            <br />
            based authentication and an assigned
            <br /> account manager,{' '}
            <b>
              all users can log <br />
              in using their academic email.
            </b>
          </>
        }
        textButton="Get a Custom Experience"
      />

      <DynamicTrustedOneHundredInstitutions textTitle="Mind the Graph's trusted by 100+ academics institutions worldwide" />

      <DynamicBookDemo />

      <Box bgcolor="#FFFFFF" py={6}>
        <DynamicCreatingScienceIllustrations textTitle="A perfect tool for students creating science illustrations" />
      </Box>

      <DynamicBenefitedDepartments />

      <Box>
        <Box pt={5}>
          <Typography className={classes.primaryColor} variant="h4" component="h2" align="center">
            <b>Mind the Graph has been cited in many journals worldwide</b>
          </Typography>
        </Box>

        <DynamicPublishedSection showTitle={false} />
      </Box>

      <DynamicReferToAcademicInstitution
        textTitle="Refer Mind the Graph to your Academic Institution"
        textSubtitle={
          <>
            If your University or College is not yet communicating <br /> science properly, refer
            Mind the Graph to them.
          </>
        }
        textInformation={
          <>
            Insert the person in charge email <br /> address below and we'll get in touch.
          </>
        }
      />
    </>
  );
}
